const AMPLITUDE_PROPERTIES = {
  ORG_ID: 'Org ID',
  ORG_NAME: 'Org Name',
  APP_ID: 'App ID',
  APP_NAME: 'App Name',
  API_ID: 'API ID',
  API_NAME: 'API Name',
  API_TYPE: 'API Type',
  RESOURCE_ID: 'RESOURCE ID',
  RESOURCE_NAME: 'RESOURCE NAME',
  RESOURCE_TYPE: 'RESOURCE TYPE',
  LOCATION_COUNT: 'Location Count',
  ORG_CMF: 'CMF',
  LOCATIONS: 'Locations',
  APIS: 'Apis',
  TRANSACTION_COUNT: 'Transaction Count',
  SELECTED_PLAN_ID: 'Selected Plan ID',
  ENTERPRISE_ID: 'Enterprise ID',
  API_PUBLISHER_NAME: 'Api Publisher Name',
  CONFIGURE_WEBHOOK: 'Configured Webhooks',
  CONFIGURE_FIELDS: 'Configured Fields',
  DOWNLOAD_ALL_TNC: 'Download All',
  NAVIGATED_FROM: 'Navigated from',
  NAVIGATED_TO: 'Navigated To',
  BUNDLE: 'Bundle',
  BUNDLE_ID: 'Bundle ID',
  BUNDLE_APIS: 'BUNDLE APIS',
  CREATE_ORDER_PAYLOAD: 'Create Order Payload',
  UPDATE_ORDER_PAYLOAD: 'Update Order Payload',
  API_PRODUCTS: 'API Products',
  ASYNC_API_INTEGRATIONS: 'Async API Integrations',
  API_PLAN_IDS: 'API Plan IDs',
  CONSENT_DATA: 'Consent Data',
};

const AMPLITUDE_EVENTS = {
  SELECT_DEALERSHIP_LOCATIONS: 'Select Dealership Locations',
  ACCEPTED_APP_TERMS: 'Accepted App Terms',
  ACCEPTED_DATA_RIGHTS: 'Accepted Data Rights',
  ACCEPTED_API_TERMS: 'Accepted Api Terms',
  CONFIGURE_DMS: 'Configure DMS',
  CONFIGURE_CPP: 'Configure CPP',
  COMPLETE_SUBSCRIPTION: 'Complete Subscription',
  VIEW_APP_MANAGEMNET: 'View App Management',
  VIEW_DATA_TRANSACTION_REPORT: 'View Data Transaction Report',
  VIEW_DEALER_INTEGRATIONS: 'View Dealer Integrations',
  USER_SIGNOUT: 'User Signout',
  GENERATE_TRANSACTION_REPORT: 'Generate Transaction Report',
  DOWNLOAD_TRANSACTION_REPORT: 'Download Transaction Report',
  MANAGE_CPP: 'Manage CPP',
  MANAGE_DMS: 'Manage DMS',
  MANAGE_INTEGRATIONS: 'Manage Integrations',
  SELECT_UNSUBSCRIBE: 'Select Unsubscribe',
  CLOSE_UNSUBSCRIBE: 'Close Unsubscribe',
  UNSUBSCRIBE: 'Unsubscribe',
  CONFIGURE_APP: 'Configure App',
  SELECT_CANCEL_SUBSCRIPTION: 'Select Cancel Subscription',
  CLOSE_CANCEL_SUBSCRIPTION: 'Close Cancel Subscription',
  CANCEL_SUBSCRIPTION: 'Cancel Subscription',
  RESUBSCRIBE: 'Resubscribe',
  ADD_LOCATIONS: 'Add Locations',
  REMOVE_LOCATIONS: 'Remove Locations',
  MANAGE_PRIVACY_PROTECTION: 'Manage Privacy Protection',
  MANAGE_DMS_ACCOUNTS: 'Manage DMS Accounts',
  APP_DOCUMENTS: 'App Documents',
  MENU_EXPAND: 'Menu Expand',
  LOCATION_COUNT: 'Location Count',
  REMOVE_LOCATIONS_CHECKBOX: 'Remove Locations Checkbox',
  REMOVE_LOCATIONS_CONFIRM: 'Remove Locations Confirm',
  REMOVE_LOCATIONS_CANCEL: 'Remove Locations Cancel',
  APP_DOCUMENT_DOWNLOAD: 'App Document Download',
  VIEW_DOCUMENTS: 'View Documents',
  BROWSE_MARKETPLACE: 'Browse Marketplace',
  MANAGE_API: 'Manage API',
  DOWNLOAD_APP_MANAGEMENT_REPORT: 'Download App Management Report',
  VIEW_ACTIVE_SUBSCRIPTIONS: 'View Active Subscriptions',
  VIEW_PENDING_SUBSCRIPTIONS: 'View Pending Subscriptions',
  VIEW_INACTIVE_SUBSCRIPTIONS: 'View InActive Subscriptions',
  VIEW_API_DIRECTORY: 'View API Directory',
  DELETE_API_VIA_STEPPER: 'Deleting API via Stepper',
  TERMS_COMPLETE_PURCHASE: 'Terms Complete Purchase',
  API_CONFIGURATION_COMPLETED: 'API Configuration Completed',
  PRICING_COMPLETED: 'Pricing Completed',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  TERMS_DOWNLOAD: 'Terms Download',
  ACCEPTED_ALL_TERMS: 'Accepted All Terms',
  COMPLETE_PURCHASE: 'Complete Order Purchase',
  UPDATE_PURCHASE: 'Update Order Purchase',
  ORDER_API_NAVIGATION: 'Order Api Navigation',
  CLOSE_MY_CART: ' Close My Cart',
  OPEN_CART: 'Open Cart',
  DELETE_API_VIA_CART: 'Deleting API via Cart',
  BACK_FROM: 'Back From',
  VIEW_DASHBOARD: 'View Dashboard',
  VIEW_MY_APIS: 'View My APIs',
  BROWSE_API_DIRECTORY: 'Browse API Directory',
  ADD_BUNDLE_TO_CART: 'ADD Bundle to Cart',
  ADD_API_TO_CART_WITH_PRICING: 'Add API to Cart with Pricing Plan',
  UPDATE_PRICING_PLAN_OF_API_IN_CART: 'Update Pricing Plan of API In Cart',
  REVIEW_CART_UPDATE_PRICING_PLAN_OF_API:
    'Review Cart Update Pricing Plan of API',
  MY_APIS: 'My APIs',
  MY_APIS_UTILIZATION: 'My APIs Utilization',
  MY_APIS_METRICS: 'My APIs Metrics',
  MY_APIS_API_ERRORS: 'My APIs API Errors',
  MY_APIS_SUBSCRIPTION_REPORT_DOWNLOADS:
    'My APIs Subscription Report Downloads',
  DEALER_DASHBOARD_SHOP_APIS: 'Dealer Dashboard Shop APIs',
  DEALER_DASHBOARD_SHOP_MARKETPLACE: 'Dealer Dashboard Shop Marketplace',
  DEALER_DASHBOARD_MY_APIS: 'Dealer Dashboard My APIs',
  DEALER_DASHBOARD_MY_APPS: 'Dealer Dashboard My Apps',
  MY_APIS_VIEW_LOCATIONS: 'My APIs View Locations',
  API_MENU_ADD_LOCATIONS: 'API Menu Add Locations',
  API_MENU_MANAGE_BUNDLE_LOCATIONS: 'API Menu Manage Bundle Locations',
  API_MENU_REMOVE_LOCATIONS: 'API Menu Remove Locations',
  API_MENU_EDIT_PRICING_PLAN: 'API Menu Edit Pricing Plan',
  API_MENU_VIEW_TERMS: 'API Menu View Terms',
  API_MENU_DELETE_API: 'API Menu Delete API',
  DELETE_API_CONFIRMATION_CANCEL: 'Delete API Confirmation Cancel',
  DELETE_API_CONFIRMATION_DELETE: 'Delete API Confirmation Delete',
  API_MENU_DELETE_BUNDLE: 'API Menu Delete Bundle',
  DELETE_BUNDLE_CONFIRMATION_CANCEL: 'Delete Bundle Confirmation Cancel',
  DELETE_BUNDLE_CONFIRMATION_DELETE: 'Delete Bundle Confirmation Delete',
  MY_APIS_EDIT_PRICING_PLAN_CANCEL: 'My APIs Edit Pricing Plan Cancel',
  MY_APIS_EDIT_PRICING_PLAN_SAVE: 'My APIs Edit Pricing Plan Save',
  MANAGE_LOCATIONS_ADD_LOCATIONS: 'Manage Locations Add Locations',
  MANAGE_LOCATIONS_REMOVE_LOCATIONS: 'Manage Locations Remove Locations',
  MY_APIS_SHOP_APIS: 'My APIs Shop APIs',
  BUNDLE_DETAILS_ADD_TO_CART: 'Bundle Details Add to Cart',
  API_DETAILS_ADD_TO_CART: 'API Details Add to Cart',
  BUNDLE_DETAILS_PRICING_PLAN_ADD_TO_CART: 'Bundle Details Pricing Plan Add to Cart',
  API_DETAILS_PRICING_PLAN_ADD_TO_CART: 'API Details Pricing Plan Add to Cart',
  DEALER_API_DIRECTORY_FILTER_BY: 'Dealer API Directory Filter By',
  DEALER_MY_CART: 'Dealer My Cart',
  DEALER_API_TILE_ADD_TO_CART: 'Dealer API Tile Add to Cart',
  DEALER_API_TILE_VIEW_IN_MY_APIS: 'Dealer API Tile View in My APIs',
  REVIEW_AND_PURCHASE: 'Review & Purchase',
  REMOVE_FROM_CART: 'Remove from Cart',
  REVIEW_CART_EDIT_PLAN: 'Review Cart Edit Plan',
  REVIEW_CART_SELECT_PLAN: 'Review Cart Select Plan',
  TERMS_BACK: 'Terms Back',
  REVIEW_CART_CONTINUE: 'Review Cart Continue',
};

export { AMPLITUDE_PROPERTIES, AMPLITUDE_EVENTS };
